import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=0c3500bb&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=0c3500bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3500bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c3500bb')) {
      api.createRecord('0c3500bb', component.options)
    } else {
      api.reload('0c3500bb', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=0c3500bb&scoped=true&", function () {
      api.rerender('0c3500bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-210DrHm22OsEz/JS/comp/GuestBox.vue"
export default component.exports